import React from "react";
import AllRecallStore from "../AllRecallStore";
import { inject, observer } from "mobx-react";
import PlusCollapsible from "../../PlusCollapsible";

interface VehicleRecallsProps {}
interface InjectedProps extends VehicleRecallsProps {
  allRecallStore: AllRecallStore;
}
const vehicleRecalls: React.SFC<VehicleRecallsProps> = (props) => {
  const { allRecallStore } = props as InjectedProps;
  const vehicleRecall = allRecallStore.vehicleRecall;

  // Guard against undefined response
  if (!vehicleRecall?.response || !allRecallStore.currentRecalls?.response) {
    return null;
  }

  const currentRecalls = allRecallStore.currentRecalls.response.filter(
    (recallCampaign) =>
      vehicleRecall.response.externalIdList.indexOf(recallCampaign.id) !== -1
  );

  const vehicleLength =
    vehicleRecall.response != null &&
    vehicleRecall.response.externalIdList.length;

  return (
    <div className="container  takataRecall">
      <div className="panel carDetails panel-default vehicle-recall">
        {vehicleRecall.response != null &&
          !vehicleRecall.isRequestError &&
          vehicleRecall.isRecallExist && (
            <div className="currentRecalls">
              {vehicleLength == 1 ? (
                <p className="total-Current-recalls">
                  There is {vehicleLength} recall for your 'SUBARU{" "}
                  {vehicleRecall.response.vehicleModel}
                  {vehicleRecall.response.vehicleSeries &&
                    " " + vehicleRecall.response.vehicleSeries}
                  ' vehicle.
                </p>
              ) : (
                <p className="total-Current-recalls">
                  There are {vehicleLength}
                  recalls for your 'SUBARU {vehicleRecall.response.vehicleModel}
                  {vehicleRecall.response.vehicleSeries &&
                    " " + vehicleRecall.response.vehicleSeries}
                  ' vehicle.
                </p>
              )}
              {!!currentRecalls.length
                ? currentRecalls.map((item, i) => {
                    return (
                      <div key={`${item.id}` + "vr"}>
                        <PlusCollapsible
                          id={item.id + "vr"}
                          title={item.title}
                          isCollapsed={false}
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item.description,
                            }}
                          />
                        </PlusCollapsible>
                      </div>
                    );
                  })
                : vehicleRecall.response.campaigns.map((item) => {
                    return (
                      <div key={`${item.id}` + "vr"}>
                        <PlusCollapsible
                          id={item.id + "vr"}
                          title={item.title}
                          isCollapsed={false}
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item.description,
                            }}
                          />
                        </PlusCollapsible>
                      </div>
                    );
                  })}
              <p className=" light text-center">
                <a href="/dealers" className="btn primary ">
                  Locate a dealer
                </a>
              </p>
            </div>
          )}
      </div>
    </div>
  );
};

export default inject("allRecallStore")(observer(vehicleRecalls));
